jQuery($ => {

  if($('.o-timeline__slider')[0]){
    $('.m-timeline-slider__slider').slick({
      slidesToShow: 1,
      slidesToScoll: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
    });
  }

});